import { CouponResponse } from "@/models/api/CouponResponse";
import baseApi from "./api.service";

const discountService = {
    apply(code: string, applyVoucher: boolean): Promise<CouponResponse> {
        return baseApi.post<CouponResponse>(`coupons/add/${code}`, { applyToBooking: applyVoucher });
    },
    remove(): Promise<void> {
        return baseApi.post<void>('coupons/remove', {});
    }
}

export default discountService;